<!-- 会员升级礼活动规则 -->
<template>
  <div class="activity-rules">
    <div class="newsInfo">活动规则</div>
    <el-form-item label="规则内容:" style="width:695px;position: relative;" required>
      <div class="rule-container">
        <el-input maxlength="2000" type="textarea" class="textarea" style="width: 543px" resize="none"
          v-model="formData.ruleDescription" :disabled="backgroundOpacity"></el-input>
        <div class="prosi" style="color: #909399">
          （{{ formData.ruleDescription.length ? formData.ruleDescription.length : 0 }}/2000）
        </div>
        <div>
          <el-button :disabled="backgroundOpacity" class="margin-t16" type="blue"
            @click="onGenerateRule">生成规则</el-button>
          <div class="rule-tip">
            <tip-box color="gley">
              提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
            </tip-box>
          </div>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import TipBox from '@/components/tip-box.vue';
export default {
  name: 'ActivityRules',
  components: {
    TipBox
  },
  props: {
    // 表单数据 (通过 v-model 传递)
    value: {
      type: Object,
      required: true
    },
    // 背景透明度控制（禁用状态）
    backgroundOpacity: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: this.value // 使用 prop 初始化本地数据
    };
  },
  watch: {
    // 监听外部 value 变化，更新本地 formData
    value: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    },
    // 监听本地 formData 变化，通过 input 事件同步到父组件
    formData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  methods: {
    // 生成规则按钮点击事件
    onGenerateRule() {
      this.$emit('generate-rule'); // 触发父组件的 generate-rule 事件
    }
  }
}
</script>

<style scoped lang="scss">
.prosi {
  position: absolute;
  bottom: 107px;
  right: 40px;
}

.margin-t16 {
  margin-top: 16px;
}

.rule-tip {
  margin-top: 8px;
}
</style>